import { Injectable } from '@angular/core'
import { TourService, IStepOption } from 'ngx-ui-tour-md-menu'
import { MatDialog } from '@angular/material/dialog'
import { BehaviorSubject } from 'rxjs'
import { TourDialogComponent } from '../dialogs/tour-dialog/tour-dialog.component'
import rpTours from '../../../assets/rpTours.json'

@Injectable({
  providedIn: 'root',
})
export class TourGuideService {
  // BehaviorSubject to hold the current tour name
  private currentTourNameSubject = new BehaviorSubject<string>('')

  // BehaviorSubject to hold the display state of the tour guide
  private displayTourGuideSubject = new BehaviorSubject<boolean>(false)

  constructor(private readonly tourService: TourService, public dialog: MatDialog) {}

  // Method to start a tour with given steps
  /* istanbul ignore next */
  start(steps: IStepOption[]) {
    // End the tour first if it's already active (required in v16+)
    if (this.tourService.getStatus() !== 0) {
      this.tourService.end()
    }
    this.tourService.initialize(steps)
    this.tourService.start()
  }

  // Method to check if the dialog is dismissed
  /* istanbul ignore next */
  isDismissed() {
    this.setDisplayTourGuide(false)
    return localStorage.getItem('dismissDialog') === 'true'
  }

  // Getter for the current tour name observable
  /* istanbul ignore next */
  get currentTourName$() {
    return this.currentTourNameSubject.asObservable()
  }

  // Method to update the current tour name
  /* istanbul ignore next */
  setCurrentTourName(name: string) {
    this.currentTourNameSubject.next(name)
  }

  // Getter for the display tour guide observable
  /* istanbul ignore next */
  get displayTourGuide$() {
    return this.displayTourGuideSubject.asObservable()
  }

  // Method to update the display state of the tour guide
  /* istanbul ignore next */
  setDisplayTourGuide(display: boolean) {
    this.displayTourGuideSubject.next(display)
  }

  /* istanbul ignore next */
  getTourSteps(tourName: string): IStepOption[] {
    const tour = rpTours.find((t) => t.tourName === tourName)
    if (!tour) {
      return []
    }

    // Ensure each step matches IStepOption
    return tour.steps.map((step) => {
      return {
        content: step.content,
        anchorId: step.anchorId,
        title: step.title,
        isAsync: step.isAsync,
        enableBackdrop: step.enableBackdrop,
        closeOnOutsideClick: step.closeOnOutsideClick,
        showProgress: step.showProgress,
        placement: step.placement,
        allowUserInitiatedNavigation: step.allowUserInitiatedNavigation,
        nextBtnTitle: step.nextBtnTitle,
        prevBtnTitle: step.prevBtnTitle,
        endBtnTitle: step.endBtnTitle || 'End',
      } as IStepOption
    })
  }

  //Open First Tour Dialog to opt in or out - only appearing on RP main accounts page
  /* istanbul ignore next */
  openTourStartDialog() {
    const steps = this.getTourSteps('Has Accounts Main')
    const dialogRef = this.dialog.open(TourDialogComponent, {
      width: '500px',
      data: {
        title: 'Welcome to Restricted Product where you can create Authorizations',
        description: 'Would you like a tour of the main accounts page?',
        start: 'Start a Quick Tour',
        optOut: 'Seen this before? Opt out',
      },
    })
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'start') {
        this.start(steps)
      }
    })
  }
}
